import { Component, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { URLS } from 'src/app/_config/api.config';
import { ApiService } from 'src/app/services/api-data.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService } from 'src/app/services/common.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-landing-healthcare',
    templateUrl: './landing-healthcare.component.html',
    styleUrls: ['./landing-healthcare.component.scss']
})
export class LandingHealthcareComponent implements OnInit {

    customOptions2: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: ['<img src="../../../assets/images/left-orange-arrow.webp">', '<img src="../../../assets/images/right-orange-arrow.webp">'],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1024: {
                items: 2
            },
            1200: {
                items: 2
            },
            1350: {
                items: 2
            }
        },
        nav: true
    }

    constructor(private router: Router,
        private toastr: ToastrService,
        private dataService: ApiService,
        public renderer: Renderer2,
        private sanitize: DomSanitizer,
        private commonService: CommonService,
        @Inject(DOCUMENT) private document: any) { }

    private subscription: Subscription = new Subscription();
    isLoading = false;
    showScroll = false;
    public faqData: any = [
        {
            _id: 1,
            sequence: 1,
            question: "What is a Healthcare Directive?",
            answer: "A Healthcare Directive is a legal document that outlines your preferences for medical treatment in the event that you’re unable to make decisions for yourself. It ensures that your healthcare providers and loved ones understand your wishes, especially during critical medical situations.",
            isCollapsed: true
        },
        {
            _id: 2,
            sequence: 2,
            question: "How does Catholic Legacy’s Healthcare Directive work?",
            answer: "Catholic Legacy’s platform guides you through the process of creating a comprehensive Catholic Healthcare Directive by asking you simple questions about who you are and what you desire in different situations. It’s free, easy to use, and ensures that your medical care reflects your values.",
            isCollapsed: true
        },
        {
            _id: 3,
            sequence: 3,
            question: "Is this service really free?",
            answer: "Yes! Catholic Legacy offers a completely free Healthcare Directive creation tool that you can use to ensure your medical wishes are respected. There are no hidden fees, and you can update your Directive anytime as your situation changes. If you appreciate the service, you can leave a donation to us after completing your document.",
            isCollapsed: true
        },
        {
            _id: 4,
            sequence: 4,
            question: "Can I update my Healthcare Directive if my medical situation changes?",
            answer: "Absolutely. You can update your Catholic Healthcare Directive anytime, at no cost, to reflect changes in your health, treatment preferences, or other factors.",
            isCollapsed: true
        },
        {
            _id: 5,
            sequence: 5,
            question: "How can I address privacy concerns regarding sensitive information stored on the platform?",
            answer: " Catholic Legacy prioritizes data security and privacy. We employ robust security measures to protect sensitive information. You can rest assured that your data is handled in accordance with relevant privacy regulations.",
            isCollapsed: true
        },
        {
            _id: 6,
            sequence: 6,
            question: "Can I get help from a Catholic Legacy representative if I have questions?",
            answer: "While we do not have the authority to give legal advice, we can readily assist you with any questions or concerns regarding using the platform, the sign-up process etc.",
            isCollapsed: true
        },
    ];

    // public testimonailData: any = [
    //     {
    //         _id: 1,
    //         sequence: 1,
    //         thumbnail: '../../../assets/images/testimonial-user.jpg',
    //         clientTestimony: 'Facing surgery was stressful, but you made it easy to create a Healthcare Directive that reflects my faith. Thank you.',
    //         clientName: 'Michael D.',
    //     },
    //     {
    //         _id: 2,
    //         sequence: 2,
    //         thumbnail: '../../../assets/images/testimonial-user.jpg',
    //         clientTestimony: 'I was pregnant and knew I was going to be in the Hospital soon. That’s when I discovered Catholic Legacy. I created a Healthcare Directive and presented it with my birth plan. I was in control and the hospital respected my wishes.',
    //         clientName: 'Kimberly A.',
    //     },
    // ];

    testimonailData: any;
    noTestimonial: boolean = false;
    carouselReady: boolean = false;

    ngOnInit(): void {
        this.getTestimonail();

        setTimeout(() => {
            this.carouselReady = true;
        }, 2000); // Adjust the delay time as needed

        const schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": 'https://www.catholiclegacy.com'
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Health",
                    "item": 'https://www.catholiclegacy.com/health'
                }
            ]
        };

        const script = this.renderer.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schema);
        this.renderer.appendChild(this.document.head, script);
    }

    toggleAccordion(data: any) {
        data.isCollapsed = !data.isCollapsed; // Toggle the clicked accordion
    }

    gotoHealthcareForm() {

        const userId = this.commonService.localStorageGet('userId')
        if (!userId) {
            sessionStorage.setItem('formId', '64e2f30f463b8795bcf3a85f');
        }
        this.commonService.localStorageSet('my-form-status-id', '64e2f30f463b8795bcf3a85f');
        this.router.navigate(['my-forms']);
    }


    getTestimonail() {
        const params = {
            isActive: true
        }
        this.subscription.add(
            this.dataService.get(URLS.getTestimonail, params).subscribe(data => {
                if (data['code'] == 200) {
                    this.testimonailData = data['data']['result'];

                    this.testimonailData = this.testimonailData.filter((element: any) => {
                        return element._id != '6523a7ca6936c3612a594d52' && element._id != '671658fc597a04112cc34fe1';
                    });

                    if (data['data']['result'].length <= 0) {
                        this.noTestimonial = true;
                    } else {
                        this.noTestimonial = false;
                    }
                } else {
                    this.toastr.error(data['message'], "Error");
                }
            }, error => {
                this.toastr.error(error['message'], "Error");
            })
        )
    }

    contactUs() {
        this.router.navigateByUrl('/contact-us');
    }

    onHome() {
        this.router.navigateByUrl('/');
    }


    @HostListener('window:scroll', [])
    onWindowScroll() {
        // Show the button when scrolled 200px down
        this.showScroll = window.scrollY > 700;
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
